import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';

import Panel from 'components/common/Panel';

import Logo from 'assets/logo.jpg';

const useStyles = createUseStyles({
  wrapper: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  logo: {
    borderRadius: '100%',
    width: '64px',
    height: '64px',
    boxShadow: ({ theme }) => theme.shadowPrimary,
    marginTop: '30px',
  },
  title: {
    fontWeight: 800,
    fontSize: '2em',
    color: '#fff',
    textAlign: 'center',
  },
  link: {
    color: ({ theme }) => theme.colorPrimary,
    textDecoration: 'none',
    '&:hover': {
      color: ({ theme }) => theme.colorNeutral,
    },
  },
});

function Credits() {
  const theme = useTheme();
  const classes = useStyles({ theme });

  return (
    <div className={classes.wrapper}>
      <img src={Logo} alt="Peasant" className={classes.logo} />
      <h1 className={classes.title}>
        Credits
      </h1>
      <Panel maxWidth="400px" style={{ alignItems: 'flex-start' }}>
        <h2 id="developers">Developers</h2>
        <ul>
          <li>Developed by <a href="https://github.com/over-engineer" className={classes.link} rel="noreferrer" target="_blank"><strong>over-engineer</strong></a></li>
          <li>Designed by <a href="https://kwnstantinos.com/" className={classes.link} rel="noreferrer" target="_blank"><strong>kwnva</strong></a></li>
        </ul>

        <h2 id="sounds">Sounds</h2>
        <p>All sound effects and loops from <a href="https://freesound.org/" className={classes.link} rel="noreferrer" target="_blank">freesound.org</a> are licensed under the Creative Commons and contributed by rhodesmas, Sjonas88 and filmfan87.</p>
        <ul>
          <li><a href="https://freesound.org/people/rhodesmas/" className={classes.link} rel="noreferrer" target="_blank"><strong>rhodesmas</strong></a> &mdash; Licensed under the <a href="https://creativecommons.org/licenses/by/3.0/" className={classes.link} rel="noreferrer" target="_blank">Creative Commons Attribution License</a></li>
          <li><a href="https://freesound.org/people/Sjonas88/" className={classes.link} rel="noreferrer" target="_blank"><strong>Sjonas88</strong></a> &mdash; Licensed under the <a href="https://creativecommons.org/publicdomain/zero/1.0/" className={classes.link} rel="noreferrer" target="_blank">Creative Commons 0 License</a></li>
          <li><a href="https://freesound.org/people/filmfan87/" className={classes.link} rel="noreferrer" target="_blank"><strong>filmfan87</strong></a> &mdash; Licensed under the <a href="https://creativecommons.org/publicdomain/zero/1.0/" className={classes.link} rel="noreferrer" target="_blank">Creative Commons 0 License</a></li>
        </ul>

        <h2 id="tech-stack">Tech stack</h2>
        <p>This app was built using the following technologies:</p>
        <ul>
          <li><a href="https://reactjs.org/" className={classes.link} rel="noreferrer" target="_blank"><strong>React</strong></a> &mdash; JavaScript library for building user interfaces</li>
          <li><a href="https://socket.io/" className={classes.link} rel="noreferrer" target="_blank"><strong>Socket.io</strong></a> &mdash; JavaScript library for realtime web applications</li>
          <li><a href="https://expressjs.com/" className={classes.link} rel="noreferrer" target="_blank"><strong>Express.js</strong></a> &mdash; Web framework for Node.js</li>
          <li><a href="https://easy-peasy.now.sh/" className={classes.link} rel="noreferrer" target="_blank"><strong>Easy Peasy</strong></a> &mdash; State management for React</li>
          <li><a href="https://www.framer.com/motion/" className={classes.link} rel="noreferrer" target="_blank"><strong>Framer Motion</strong></a> &mdash; Motion library for React</li>
        </ul>
      </Panel>
    </div>
  );
}

export default Credits;
